import { ThemeConfig } from "antd";

export const getThemeConfig = (): ThemeConfig | undefined => {
  return {
    token: {
      colorPrimary: "#2b872b",
    },
    components: {
      Menu: {
        colorItemBgSelected: "#ffffff",
        colorItemTextSelected: "#2b872b",
        colorSubItemBg: "#ffffff",
        controlHeightLG: 40,
      },
      Select: {
        controlHeight: 40
      }, 
      DatePicker: {
        controlHeight: 40
      },
      Input: {
        controlHeight: 40
      }
    },
  };
};
